var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"_logo"},[_vm._v(" 动环监控管理平台 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }